import { useContext } from 'react'

import GeoContext from 'contexts/geoContext'
import { formatDynamicAmountWithDollarType } from 'lib/format/formatCurrencyIntl'
import BookingItemCard from 'tripPlanner/components/ItemCard/BookingItemCard'
import type { OfferTypeForTripItemTypes } from 'tripPlanner/hooks/api/common'
import { concatStringWithDot } from 'tripPlanner/utils'

type Props = {
  bedbankOrderItem: App.OrderBedbankItem
  showBorder?: boolean
  order?: App.Order
  onSelect?: (
    order: App.Order,
    offers: Array<OfferTypeForTripItemTypes>,
    checked: boolean,
  ) => void
}

function BedBankBookingCard(props: Props) {
  const { currentCurrency, currentRegionCode } = useContext(GeoContext)
  const { bedbankOrderItem, showBorder, order, onSelect } = props
  const { offer } = bedbankOrderItem

  return (
    <BookingItemCard
      onSelect={(checked) => {
        if (onSelect && order) {
          onSelect(order, [offer], checked)
        }
      }}
      heading={offer.name}
      image={offer.image}
      subHeading={concatStringWithDot(
        `${bedbankOrderItem.checkIn.format(
          'DD MMM',
        )} – ${bedbankOrderItem.checkOut.format('DD MMM YYYY')}`,
        formatDynamicAmountWithDollarType(
          bedbankOrderItem.total,
          currentCurrency,
          currentRegionCode,
        ),
      )}
      showBorder={showBorder}
    />
  )
}

export default BedBankBookingCard
